<template>
    <div class="container">
        <div class="left">
            <div style="padding:10px 0">
                <el-select v-model="model" slot="prepend" placeholder="please choose" @change="search">
                    <el-option label="cl4" value="cl4"></el-option>
                    <el-option label="808_W" value="White808"></el-option>
                    <el-option label="808_B" value="black808"></el-option>
                    <el-option label="clsFace" value="clsFace"></el-option>
                    <el-option label="all" value=""></el-option>
                </el-select>
                <el-input placeholder="Please enter the machine number" v-model="machine" suffix-icon="el-icon-search" @change="search" clearable
                    style="width: 250px; margin-left: 5px;"></el-input>
                <el-input placeholder="Please enter country" v-model="country" suffix-icon="el-icon-search" @change="search" clearable
                    style="width: 250px; margin-left: 5px;"></el-input>
                <el-input placeholder="Please enter city" v-model="city" suffix-icon="el-icon-search" @change="search" clearable
                    style="width: 250px; margin-left: 5px;"></el-input>
                <el-button @click="search" style="margin-left:10px" @change="search" type="primary">search</el-button>
            </div>
            <div style="padding-top:5px;padding-bottom: 10px;">
                <el-button type="primary" @click="openDialog" icon="el-icon-circle-plus-outline">Increase</el-button>
                <el-button type="primary" @click="exportData" icon="el-icon-upload2">Export</el-button>
                <el-button type="warning" icon="el-icon-remove-outline" @click="openPop">batch deletion</el-button>
            </div>
            <el-table :data="tableData" border style="width: 80%" @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="50" align="center">
                </el-table-column>
                <el-table-column prop="time" label="date" width="200" align="center">
                </el-table-column>
                <el-table-column prop="machine" label="Machine name" width="200" align="center">
                </el-table-column>
                <el-table-column
                    prop="model"
                    label="model"
                    width="130"
                    align="center">
                    <template v-slot="scope">
                    <span v-if="scope.row.model === 'white808'">808_W</span>
                    <span v-else-if="scope.row.model === 'black808'">808_B</span>
                    <span v-else>{{ scope.row.model }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="country" label="nation" width="100" align="center">
                </el-table-column>
                <el-table-column prop="city" label="City" width="150" align="center">
                </el-table-column>
                <el-table-column label="operate" align="center">
                    <template slot-scope="scope">
                        <el-button style="margin-right:2%" type="success" icon="el-icon-share"
                            @click="switchToMachine(scope.row)" circle></el-button>
                        <el-popconfirm confirm-button-text='Sure' cancel-button-text='Cancel' icon="el-icon-info" icon-color="red"
                            title="Are you sure to delete it?" @confirm="del(scope.row)">
                            <el-button slot="reference" type="danger" icon="el-icon-delete" circle></el-button>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>
            <div style="padding:10px 0">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
                    :page-sizes="[5, 10, 15, 20]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
            <el-dialog title="add machine" :visible.sync="dialogFormVisible" width="25%">
                <el-form :model="form" label-width="130px">
                    <el-form-item label="machine code:">
                        <el-input v-model="form.machine" autocomplete="off" @input="machineOnInput"></el-input>
                    </el-form-item>
                    <div style="display: grid; place-items: center;">
                        <div style="text-align: center;">or</div>
                    </div>
                    <el-form-item label="Upload QR code:">
                        <el-upload class="upload-demo" action="https://www.qihang.store/sb/file/qrCode"
                            :on-preview="handlePreview" :on-remove="handleRemove" :before-remove="beforeRemove"
                            :on-success="handleAvatarSuccess" :file-list="fileList">
                            <el-button size="small" type="primary" @click="handleClickUpload">Click to upload</el-button>
                            <div slot="tip" class="el-upload__tip">Only jpg/png files can be uploaded and should not exceed 10mb</div>
                        </el-upload>
                    </el-form-item>

                    <el-form-item label="Machine type:">
                        <el-select v-model="form.model" placeholder="Please select machine type">
                            <el-option label="cl4" value="cl4"></el-option>
                            <el-option label="808_W" value="white808"></el-option>
                            <el-option label="808_B" value="black808"></el-option>
                            <el-option label="cl4Face" value="cl4Face"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisible = false;">Cancel</el-button>
                    <el-button type="primary" @click="save">Sure</el-button>
                </div>
            </el-dialog>
        </div>
        <div>

        </div>
        <div class="right">
            <div id="pieChart" style="width: 600px; height: 400px;"></div>
        </div>
    </div>
</template>
<script>
import request from '@/utils/request';
import * as echarts from 'echarts';
export default {
    data() {
        return {
            level :JSON.parse(localStorage.getItem('userData')).level,
            fileList: [], // 用于存储上传的文件列表
            eChartData: [],
            tableData: [],
            total: 0,
            pageNum: 1,
            pageSize: 10,
            model: "",
            machine: "",
            country: "",
            city: "",
            dialogFormVisible: false,
            dialogFormMachineAdd: false,
            form: {
                userID: JSON.parse(localStorage.getItem('userData')).userID,
                country: '',
                model: '',
                machine: '',
            },
            forms: [

            ],
            selection: true,
            multipleSelection: [],
        }
    },

    created() {
        this.$store.state.teb.default_active = '0';
        this.$store.commit('clearTabsListExceptFirst')
        this.load()

    },
    methods: {
        async exportData() {
            try {
                const url = `https://www.qihang.store/sb/user/export?userID=${JSON.parse(localStorage.getItem('userData')).userID}&model=${this.model}&machine=${this.machine}&country=${this.country}&city=${this.city}`;
                // 打开新窗口请求导出接口
                window.open(url);
            } catch (error) {
                console.error("Error:", error);
            }
        },
        openPop() {
            this.$confirm('This operation will be permanently deleted. Do you want to continue?', 'hint', {
                confirmButtonText: 'Sure',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.delBach()
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: 'Undelete'
                });
            });
        },
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.load();
        },

        handleCurrentChange(pageNum) {
            this.pageNum = pageNum;
            this.load();
        },
        load() {
            request.get("/user/selectAll", {
                params: {
                    userID: JSON.parse(localStorage.getItem("userData"))?.userID,
                    pageSize: this.pageSize,
                    pageNum: this.pageNum,
                    model: this.model,
                    machine: this.machine,
                    country: this.country,
                    city: this.city
                }
            }).then(res => {
                console.log(res)
                this.tableData = res.data;
                this.total = res.count;
            }).catch(error => {
                console.error("Error:", error);
            });
            request.get("/user/eChart", {
                params: {
                    userID: JSON.parse(localStorage.getItem("userData"))?.userID,
                }
            }).then(res => {
                if (res.code === "SUCCESS") {
                    this.eChartData = res.data
                    this.initChart()
                }
            })
        },
        fetchWhite808Data() {
            this.$store.dispatch('getMachineID', { mode: 'white808', userID: JSON.parse(localStorage.getItem("userData"))?.userID });
        },
        fetchBlack808Data() {
            this.$store.dispatch('getMachineID', { mode: 'black808', userID: JSON.parse(localStorage.getItem("userData"))?.userID });
        },
        fetchCl4Data() {
            this.$store.dispatch('getMachineID', { mode: 'cl4', userID: JSON.parse(localStorage.getItem("userData"))?.userID });
        },
        fetchCl4FaceData(){
            this.$store.dispatch('getMachineID',{ mode: 'cl4Face',userID: JSON.parse(localStorage.getItem("userData"))?.userID})
        },
        search() {
            this.pageNum = 1;
            this.load();
        },
        handleEnter() {
            // 处理回车事件的逻辑
            console.log('Enter key pressed');
            // 可以在这里调用查询函数或其他相关操作
        },
        save() {
            request.post("/user/insert", this.form).then(res => {
                if (res == 1) {
                    this.load()
                    this.fetchBlack808Data();
                    this.fetchWhite808Data();
                    this.fetchCl4Data();
                    this.fetchCl4FaceData();
                    this.dialogFormVisible = false
                    this.$message.success("Saved successfully")
                    this.form.machine = ""
                } else if (res == -1) {
                    this.$message.error("Failed to save, please enter the correct machine number")
                } else if (res == 0) {
                    this.$message.error("Save failed, please select the correct machine type")
                } else if (res == -2) {
                    this.$message.error("Save failed, you have added a new machine")
                }
            })
        },
        del(row) {
            request.get("/user/deleteOne", {
                params: {
                    userID: row.userID,
                    machine: row.machine
                }
            }).then(res => {
                this.load()
                this.fetchBlack808Data();
                this.fetchWhite808Data();
                this.fetchCl4Data();
                this.fetchCl4FaceData();
            })
        },
        switchToMachine(row) {
            this.$store.state.teb.machineID = row.machine
            console.log("modle  :"+row.model +"   machine : "+row.machine)
            if (row.model === 'cl4') {
                this.$store.commit('getClsPosition', row.machine)
                this.$router.push('/cl4')
            } else if (row.model === 'white808') {
                this.$store.commit('getWhite808Position', row.machine)
                this.$router.push('/white808')
            } else if (row.model === 'black808') {
                this.$store.commit('getBlack808Position', row.machine)
                this.$router.push('/black808')
            } else if(row.model ==='cl4Face'){
                this.$store.commit('getCl4FacePosition',row.machine)        //获取getCl4Face machine 的位置。 如 4-1 ; 4-2 
                this.$router.push('/cl4Face')
            }
        },

        handleSelectionChange(val) {
            this.multipleSelection = val
        },
        delBach() {
            let ids = this.multipleSelection.map(item => {
                return { userID: item.userID, machine: item.machine };
            });
            if (ids.length !== 0) {
                request.post("/user/batchDel", ids).then(res => {
                    this.load()
                    this.fetchBlack808Data();
                    this.fetchWhite808Data();
                    this.fetchCl4Data();
                    this.fetchCl4FaceData();
                    this.$message({
                        type: 'success',
                        message: 'successfully deleted!'
                    });
                })
            } else {
                this.$message({
                    type: 'error',
                    message: 'Please check the form'
                })
            }
        },
        initChart() {
            const myChart = echarts.init(document.getElementById('pieChart'));
            //处理数据
            // const legendData = this.eChartData.map(item => item.model);
            const legendData = this.eChartData.map(item => {
                if (item.model === 'white808') {
                    return '808_W';
                } else if (item.model === 'black808') {
                    return '808_B';
                }
                return item.model;
            });
            // const seriesData = this.eChartData.map(item => ({ value: item.number, name: item.model }))
            const seriesData = this.eChartData.map(item => {
                let name = item.model;
                if (item.model === 'white808') {
                    name = '808_W';
                } else if (item.model === 'black808') {
                    name = '808_B';
                }
                return { value: item.number, name };
            });
            //指定表格的配置项和数据原
            const option = {
                title: {
                    text: 'Machine type scale diagram',
                    left: 'center'
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b} : {c} ({d}%)'
                },
                legend: {
                    orient: 'vertical',
                    left: 'left',
                    data: legendData
                },
                series: [
                    {
                        name: 'Model',
                        type: 'pie',
                        radius: '55%',
                        center: ['50%', '60%'],
                        data: seriesData
                    }
                ],
                emphasis: {
                    itemStyle: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                }
            }
            // 使用配置项绘制图表
            myChart.setOption(option);
        },
        handleRemove(file, fileList) {
            console.log(file, fileList);
        },
        handlePreview(file) {
            console.log(file);
        },
        handleExceed(files, fileList) {
        },
        beforeRemove(file, fileList) {
            return this.$confirm(`确定移除 ${file.name}？`);
        },
        handleClickUpload() {
            // 清空 fileList 数组
            this.form.machine = ''
            this.fileList = [];
        },
        handleAvatarSuccess(res, file) {
            console.log('服务器返回的数据：', res);
            if (res.length > 6) {
                if (res.slice(0, 6) === "cpuid:") {
                    this.form.machine = res.substring(6).substring(0, res.substring(6).length - 1);
                }
            } else {
                this.$message.error("Parsing failed, please upload a clearer QR code.")
                this.fileList = [] 
            }
        },
        machineOnInput() {
            this.fileList = []
        },
        openDialog() {
            this.form.machine = '';
            this.form.mode = '';
            this.fileList = [];
            // Log the user level to the console
            console.log("user level " + this.level);

            // Check if the user has the required permission level
            if (this.level === '1') {
                this.dialogFormVisible = true;  // Show the dialog form
            } else {
                this.$message.error("Your account does not have permission to add machines");  // Show an error message
            }
        },
        showdialog() {
            this.dialogFormMachineAdd = true;
        }

    },
    watch: {
        dialogHide(newVal, oldVal) {
            this.form.machine = ''
            this.form.model = ''
        },
    },
    computed: {
        machineID() {
            return this.dialogFormVisible; // 注意这里的命名
        },
    },

}
</script>

<style lang="less" scoped>
.el-table {
    max-width: 100%;
    /* 设置表格最大宽度为容器宽度 */
}

/* 对表格列进行调整 */
.el-table-column {
    word-break: break-all;
    /* 当内容过长时自动换行 */
}

.left {
    flex: 1;
    /* 左侧占据剩余空间 */
}

.right {
    width: 25%;
    /* 右侧宽度 */
    display: flex;
    justify-content: center;
    align-items: center;
}

.container {
    display: flex;
    /* 使用 Flexbox 布局 */
}
</style>